/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_FinalInputs */

const th_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จบแล้ว`)
};

const en_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final`)
};

const ja_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合終了`)
};

const zh_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`终场`)
};

const es_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final`)
};

const pt_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Final`)
};

const id_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akhir`)
};

const fr_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const tl_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapos`)
};

const vi_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chung cuộc`)
};

const ko_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최종`)
};

const de_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endstand`)
};

const ru_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Итог`)
};

const tr_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitiş`)
};

const it_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finale`)
};

const pl_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koniec`)
};

const uk_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підсумок`)
};

const hi_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम`)
};

const ar_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النهاية`)
};

const ms_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamat`)
};

const bn_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চূড়ান্ত`)
};

const zh_tw2_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終場`)
};

const zh_hk2_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終場`)
};

const ur_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حتمی`)
};

const fa_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پایانی`)
};

const sw_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwisho`)
};

const nl_status_final = /** @type {(inputs: Status_FinalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eindstand`)
};

/**
* | output |
* | --- |
* | "Final" |
*
* @param {Status_FinalInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const status_final = /** @type {((inputs?: Status_FinalInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_FinalInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_status_final(inputs)
	if (locale === "ja") return ja_status_final(inputs)
	if (locale === "zh") return zh_status_final(inputs)
	if (locale === "es") return es_status_final(inputs)
	if (locale === "pt") return pt_status_final(inputs)
	if (locale === "id") return id_status_final(inputs)
	if (locale === "fr") return fr_status_final(inputs)
	if (locale === "tl") return tl_status_final(inputs)
	if (locale === "vi") return vi_status_final(inputs)
	if (locale === "ko") return ko_status_final(inputs)
	if (locale === "de") return de_status_final(inputs)
	if (locale === "ru") return ru_status_final(inputs)
	if (locale === "tr") return tr_status_final(inputs)
	if (locale === "it") return it_status_final(inputs)
	if (locale === "pl") return pl_status_final(inputs)
	if (locale === "uk") return uk_status_final(inputs)
	if (locale === "hi") return hi_status_final(inputs)
	if (locale === "ar") return ar_status_final(inputs)
	if (locale === "ms") return ms_status_final(inputs)
	if (locale === "bn") return bn_status_final(inputs)
	if (locale === "zh-TW") return zh_tw2_status_final(inputs)
	if (locale === "zh-HK") return zh_hk2_status_final(inputs)
	if (locale === "ur") return ur_status_final(inputs)
	if (locale === "fa") return fa_status_final(inputs)
	if (locale === "sw") return sw_status_final(inputs)
	if (locale === "nl") return nl_status_final(inputs)
	return en_status_final(inputs)
});